/**
 * @function to call country list api
 * @param reqObj 
 * @returns top countries, country list
 */

const triggerCountryList = reqObj => {
  try {
    const getPayloadListEntries = () => {
      const countryListObj = {"name": "COUNTRY_LIST","type": "country"};
      const senderCountryListObj = {"name": "sender_country_list","type": "lang"};
      const topCountriesObj = {"name": "TOP_COUNTRIES","type": "country"};
      const countryListGCR = {"name":"COUNTRY_LIST_GCR","type":"country"};
      
      if (WuAmerigoConfigs.isAmerigo() && reqObj.language === 'ar') {
         return [countryListObj, senderCountryListObj];
      } else if (WuAmerigoConfigs.isAmerigo()) {
        return [senderCountryListObj];
      } else {
        return [countryListObj, senderCountryListObj,topCountriesObj, countryListGCR];
      }
    }
    const reqPayload = { // TODO: Add realtime session id in the payload
      "origination": reqObj.country,
      "language": reqObj.language,
      "lists": getPayloadListEntries(),
      "bashPath": `/${reqObj.country}/${reqObj.language}`
    }
    const host = getHttpRequestUrl(reqObj.host, reqObj.country.toLowerCase());

    return {
      reqPayload,
      url: `${host}wuconnect/dcaas/list.optimus.json`
    }
  } catch (e) {
    console.warn('Error in list optimus api', e)
  }
}
// https://www.westernunion.com/content/wucom/base/global/config/activeVersion.json
// https://wudispatcher-uatrs2.westernunion.com/wuconnect/dcaas/list.optimus.json?dcaasversion=R220820
